import { combineReducers } from 'redux';

import usuario from './usuario';
import periodo from './periodo';
import sistema from './sistema';
import escola from './escola';
import parametros from './parametros';

export default combineReducers({ usuario, sistema, escola, periodo, parametros});
